<template>
  <b-card v-if="dataset" class="molecule-progress-bar_card">
    <div v-if="title || subTitle" class="molecule-progress-bar_header">
      <div v-if="title" class="header__title">{{ title }}</div>
    </div>
    <div
      class="molecule-progress-bar_graph row m-0 d-flex justify-content-between"
    >
      <div
        v-for="(item, index) in dataset"
        :key="index"
        class="col-sm-6 p-0"
        :class="index % 2 === 0 ? 'pr-sm-1' : 'pl-sm-1'"
      >
        <div class="d-flex justify-content-between">
          <div class="progress-bar__container">
            <atom-bootstrap-progress-bar
              color="primary"
              :title="`${item.diskMountPath}${item.diskMountName}`"
              :subTitle="`${item.diskAvailableGb} / ${item.diskTotalGb} GB`"
              :value="item.diskPercentUsed"
            ></atom-bootstrap-progress-bar>
          </div>
          <div class="mt-1 text-width d-flex justify-content-end">
            <b-badge variant="light-dark">{{item.diskPercentUsed.toFixed(2)}} %</b-badge>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard, BBadge } from "bootstrap-vue"
import AtomBootstrapProgressBar from "@/components/atoms/graphs/AtomBootstrapProgressBar.vue"
export default {
  name: "MoleculeProgressBarList",
  components: { BCard, BBadge, AtomBootstrapProgressBar },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    dataset: {
      type: [Array, null],
      required: false,
      default: null,
      // value = [ { title, subTitle, color, value, max}]
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 0;
}

.molecule-progress-bar_card {
  width: 100%;
}

.item--flex {
  display: flex;
}

.item--flex-end {
  justify-content: flex-end;
}

// header
.molecule-progress-bar_header {
  display: flex;
  padding-right: 20px;
  justify-content: space-between;
}
.header__title {
  color: #5e5873;
  font-size: 18px;
  font-weight: 500;
}
.header__sub-title {
  color: #b9b9c3;
  font-size: 14px;
}

// graph
.molecule-progress-bar_graph {
  margin-top: 20px;
  margin-bottom: 10px;
  padding-top: 10px;
  width: 100%;
  height: 230px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

// margin-top-20px
.margin-top-20px {
  margin-top: 20px;
}

.progress-bar__container {
  width: calc(100% - 20px);
  padding-right: 20px;
}

.text-width {
  width: 62px;
}

::v-deep .progress {
  height: 8px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
